<template>
  <div class="layout-wrapper">
    <main class="container">
      <Header />
      <div class="content-area">
        <slot />
      </div>
      <Footer />
    </main>
  </div>
</template>

<script setup lang="ts">
import Header from "../components/Header.vue"
import Footer from "../components/Footer.vue"
</script>
